export const NAME = 'onboarding' as const;
export const ONBOARDING_NODE_ID = NAME;

export enum STACK_LEVEL {
  background = 0,
  clone = 1,
  element = 2,
  tooltip = 3,
}
